import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID

// グローバルで初期化
if (measurementId) {
  ReactGA.initialize(measurementId)
}

export const useGA4 = () => {
  const location = useLocation()

  useEffect(() => {
    if (measurementId) {
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search })
    }
  }, [location.pathname, location.search])
}